<script>
	import { createEventDispatcher } from "svelte";
	import { uiText } from "../lib/uiText.js";
	import {
		doc,
		collection,
		addDoc,
		setDoc,
		getDoc,
		updateDoc,
		arrayUnion,
		onSnapshot,
		deleteField,
		serverTimestamp,
		increment,
		Timestamp,
		query,
		limit,
		orderBy,
		where,
	} from "firebase/firestore";
	import OrderView from "./OrderView.svelte";

	const dispatch = createEventDispatcher();

	// export let auth;
	export let db;
	export let lang;
	export let loader;
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });
	$: loader, dispatch("loader", loader), (ui = uiText(lang));

	let xml = "";

	const now = new Date();

	// first day of current month
	const firstDayThisMonth = new Date(now.getFullYear(), now.getMonth(), 1);

	// first day of previous month
	const firstDayPrevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);

	// last moment of previous month
	const lastDayPrevMonth = new Date(firstDayThisMonth.getTime() - 1);

	const start = Timestamp.fromDate(firstDayPrevMonth);
	const end = Timestamp.fromDate(lastDayPrevMonth);

	let orders = [];
	let perPage =
		localStorage.getItem("nPerPage") === null
			? 10
			: localStorage.getItem("nPerPage");
	$: perPage, () => localStorage.setItem("nPerPage", perPage), loadOrders();

	//Load orders for previous month
	function loadOrders() {
		// const q = query(
		// 	collection(db, "orders"),
		// 	limit(perPage),
		// 	orderBy("timeOfOrder", "desc"),
		// );

		const q = query(
			collection(db, "orders"),
			where("timestamp", ">=", start),
			where("timestamp", "<=", end),
			orderBy("timestamp", "desc"),
			// limit(perPage),
		);
		const unsubscribe = onSnapshot(q, (querySnapshot) => {
			let querySet = [];
			querySnapshot.forEach((doc) => {
				querySet.push(doc.data());
			});
			orders = querySet;
			console.log(orders);
		});
	}
	loadOrders();

	function formatDateFromSeconds(seconds) {
		const d = new Date(seconds * 1000);
		return d.toISOString().split("T")[0];
	}

	function centsToCurrency(cents) {
		return (cents / 100).toFixed(2);
	}

	function encodeCP1251(str) {
		const cp1251 = new Uint8Array(str.length);

		for (let i = 0; i < str.length; i++) {
			const code = str.charCodeAt(i);

			if (code < 128) {
				cp1251[i] = code;
			} else if (code >= 1040 && code <= 1103) {
				// А-я
				cp1251[i] = code - 848;
			} else if (code === 1025) {
				cp1251[i] = 168; // Ё
			} else if (code === 1105) {
				cp1251[i] = 184; // ё
			} else {
				cp1251[i] = 63; // fallback '?'
			}
		}

		return cp1251;
	}

	function generateOrderXML(order, index) {
		console.log("working on generateOrderXML");
		const date = formatDateFromSeconds(order.timeOfOrder);

		const total = order.amountTotal / 100;
		const quantity = order.xmlData.count;

		const unitPrice = (total / quantity).toFixed(2);
		const totalPrice = total.toFixed(2);
		const transN = order.xmlData.id.replace("cs_live_", "");

		return `
    <orderenum>
      <ord_n>${index + 1}</ord_n>
      <ord_d>${date}</ord_d>
      <art>
        <artenum>
          <art_name>${order.xmlData.product}</art_name>
          <art_quant>${quantity}</art_quant>
          <art_price>${unitPrice}</art_price>
          <art_vat_rate>0</art_vat_rate>
          <art_vat>0.00</art_vat>
          <art_sum>${totalPrice}</art_sum>
        </artenum>
      </art>
      <ord_total1>${totalPrice}</ord_total1>
      <ord_disc>0.00</ord_disc>
      <ord_vat>0.00</ord_vat>
      <ord_total2>${totalPrice}</ord_total2>
      <paym>5</paym>
      <trans_n>${transN}</trans_n>
    </orderenum>
  `;
	}
	function generateXML(orders, monthDate) {
		console.log("working on generateXML");
		// orders.reverse();
		// const orderBlocks = orders.map(generateOrderXML).join("\n");
		const orderBlocks = orders
			.map((order, idx) => generateOrderXML(order, idx))
			.join("\n");

		const creationDate = new Date().toISOString().split("T")[0];

		const mon = String(monthDate.getMonth() + 1).padStart(2, "0");
		const god = monthDate.getFullYear();

		return `<?xml version="1.0" encoding="windows-1251"?>
<audit>
  <eik>207295434</eik>
  <e_shop_n>RF0004795</e_shop_n>
  <domain_name>www.vutreshenglas.com</domain_name>
  <creation_date>${creationDate}</creation_date>
  <mon>${mon}</mon>
  <god>${god}</god>
  <e_shop_type>1</e_shop_type>
  <order>

${orderBlocks}

  </order>
</audit>`;
	}
	// function downloadXML(orders, monthDate) {
	//   const xml = generateXML(orders, monthDate);

	//   const blob = new Blob([xml], { type: "application/xml" });

	//   const url = URL.createObjectURL(blob);

	//   const a = document.createElement("a");
	//   a.href = url;
	//   a.download = `orders-${monthDate.getFullYear()}-${monthDate.getMonth()+1}.xml`;

	//   document.body.appendChild(a);
	//   a.click();

	//   document.body.removeChild(a);
	//   URL.revokeObjectURL(url);
	// }

	function previewXML(orders, firstDayPrevMonth, lastDayPrevMonth) {
		const paidOrders = orders.filter((o) => o.paymentStatus === "paid");

		// Sort chronologically: earliest first
		paidOrders.sort((a, b) => a.timeOfOrder - b.timeOfOrder);

		// Generate XML string
		xml = generateXML(paidOrders, firstDayPrevMonth);
	}

	function downloadXML(orders, firstDayPrevMonth, lastDayPrevMonth) {
		console.log("generating");
		// xml = generateXML(orders, firstDayPrevMonth);
		// console.log(xml);
		const paidOrders = orders.filter((o) => o.paymentStatus === "paid");

		// Sort chronologically: earliest first
		paidOrders.sort((a, b) => a.timeOfOrder - b.timeOfOrder);

		// Generate XML string
		xml = generateXML(paidOrders, firstDayPrevMonth);

		const encoded = encodeCP1251(xml);

		const blob = new Blob([encoded], {
			type: "application/xml;charset=windows-1251",
		});

		const url = URL.createObjectURL(blob);

		const a = document.createElement("a");
		a.href = url;

		const filename = `www-vutreshenglas-com-${firstDayPrevMonth.getFullYear()}-${pad(firstDayPrevMonth.getMonth() + 1)}-${pad(firstDayPrevMonth.getDate())}-${lastDayPrevMonth.getFullYear()}-${pad(lastDayPrevMonth.getMonth() + 1)}-${pad(lastDayPrevMonth.getDate())}.xml`;

		a.download = filename;
		// a.download = `www-vutreshenglas-com-${firstDayPrevMonth.getFullYear()}-${firstDayPrevMonth.getMonth() + 1}-${firstDayPrevMonth.getDay()}-${lastDayPrevMonth.getFullYear()}-${lastDayPrevMonth.getMonth() + 1}-${lastDayPrevMonth.getDay()}.xml`;

		document.body.appendChild(a);
		a.click();

		document.body.removeChild(a);
		URL.revokeObjectURL(url);
	}

	function pad(n) {
		return String(n).padStart(2, "0");
	}
	// attach download button listener
	// document.getElementById("downloadXML").onclick = () => {
	// 	const orders = querySnapshot.docs.map((doc) => doc.data());
	// 	downloadXML(orders, firstDayPrevMonth);
	// };
</script>

<!--  -->
<!--  -->
<!--  -->
<p class="mt-6 uppercase">VG Panel</p>
<h1>
	Orders from lasth month - {Intl.DateTimeFormat("bg-bg", {
		month: "long",
		year: "numeric",
	}).format(firstDayPrevMonth)}
</h1>

<button
	id="previewXML"
	on:click={() => previewXML(orders, firstDayPrevMonth, lastDayPrevMonth)}
	>👀 Preview XML</button
>
<button
	id="downloadXML"
	on:click={() => downloadXML(orders, firstDayPrevMonth, lastDayPrevMonth)}
	>⬇️ Download XML</button
>

<div class="flex flex-wrap gap-6 my-6 bg-black/20 p-4 rounded">
	<pre><code>{xml}</code></pre>
</div>

<div class="flex flex-wrap gap-6 my-6">
	{#each orders as order}
		<OrderView {order} />
	{/each}
</div>

<!-- <select
	name="nPerPage"
	id="nPerPage"
	bind:value={perPage}
	on:change={(perPage = perPage)}
	class="p-4"
	placeholder="10"
>
	<option value="10">10</option>
	<option value="15">15</option>
	<option value="20">20</option>
	<option value="30">30</option>
	<option value="50">50</option>
</select> -->
